import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import notFoundBg from '../images/notFoundBg.jpg'

const NotFound = () => {
    return (
        <div>
            <Navbar />
            <div className="d-flex justify-content-center pt-5 mt-5">
                <div>
                    <h3 class="blockquote-footer px-5">
                        Sorry Page Not Found!<cite title="Source Title"></cite>
                    </h3>
                    {/* <h3 class="blockquote-footer px-5">
                    <Link to='/home'>Back to home</Link> <cite title="Source Title"></cite>
                </h3> */}
                    <div className="d-flex justify-content-center">
                        <img className="img-fluid" style={{ height: '500px' }} src={notFoundBg} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;